import { Editor } from '@tldraw/tldraw'
import { FrameShapeUtil } from 'components/VisualStudioPlayground/Shapes/FrameShape/FrameShapeUtil'
import { FrameShape } from 'components/VisualStudioPlayground/Shapes/FrameShape/Types'
import { getOrderedFrames } from 'components/VisualStudioPlayground/Shapes/FrameShape/helpers'

export const isBlankDesign = (editor: Editor) => {
  const frames = getOrderedFrames(editor)
  if (frames.length !== 1) {
    return false
  }
  const shapeUtil = editor.getShapeUtil<FrameShape>(frames[0]) as FrameShapeUtil
  return shapeUtil.isBlank(frames[0])
}
